// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1sF7C","amount":"Amount_amount__38O0E","tip":"Amount_tip__33w8I","tipHeader":"Amount_tipHeader__OsJw-","tipsWrap":"Amount_tipsWrap__37d4C"};